export default {
      id: "malanka-usage",
      viewBox: "0 0 11 21",
      url: __webpack_public_path__ + "img/icons.svg#malanka",
      toString: function () {
        return this.url;
      }
    }